/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileLookingFor } from '../../models/profile-looking-for';
import { SortType } from '../../models/sort-type';
import { StudentProfilePagedData } from '../../models/student-profile-paged-data';
import { StudentProfileType } from '../../models/student-profile-type';

export interface GetStudentProfiles$Params {
  PageNumber?: number;
  PageSize?: number;
  MinimumMatchPercentage?: number;
  ReferenceCode?: string;
  SearchTerm?: string;
  'Address.Street'?: string;
  'Address.Number'?: string;
  'Address.NumberSuffix'?: string;
  'Address.PostalCode'?: string;
  'Address.City'?: string;
  'Address.Country'?: string;
  'Address.Latitude'?: number;
  'Address.Longitude'?: number;
  MaximumDistance?: number;
  AreaOfInterests?: Array<string>;
  ProfileType?: StudentProfileType;
  LookingFor?: ProfileLookingFor;
  EducationLevels?: Array<string>;
  TargetGroups?: Array<string>;
  LanguageCodes?: Array<string>;
  EducationSearchTerm?: string;
  HasCallForOpportunity?: boolean;
  Tags?: Array<string>;
  SortField?: string;
  SortType?: SortType;
}

export function getStudentProfiles(http: HttpClient, rootUrl: string, params?: GetStudentProfiles$Params, context?: HttpContext): Observable<StrictHttpResponse<StudentProfilePagedData>> {
  const rb = new RequestBuilder(rootUrl, getStudentProfiles.PATH, 'get');
  if (params) {
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
    rb.query('MinimumMatchPercentage', params.MinimumMatchPercentage, {});
    rb.query('ReferenceCode', params.ReferenceCode, {});
    rb.query('SearchTerm', params.SearchTerm, {});
    rb.query('Address.Street', params['Address.Street'], {});
    rb.query('Address.Number', params['Address.Number'], {});
    rb.query('Address.NumberSuffix', params['Address.NumberSuffix'], {});
    rb.query('Address.PostalCode', params['Address.PostalCode'], {});
    rb.query('Address.City', params['Address.City'], {});
    rb.query('Address.Country', params['Address.Country'], {});
    rb.query('Address.Latitude', params['Address.Latitude'], {});
    rb.query('Address.Longitude', params['Address.Longitude'], {});
    rb.query('MaximumDistance', params.MaximumDistance, {});
    rb.query('AreaOfInterests', params.AreaOfInterests, {});
    rb.query('ProfileType', params.ProfileType, {});
    rb.query('LookingFor', params.LookingFor, {});
    rb.query('EducationLevels', params.EducationLevels, {});
    rb.query('TargetGroups', params.TargetGroups, {});
    rb.query('LanguageCodes', params.LanguageCodes, {});
    rb.query('EducationSearchTerm', params.EducationSearchTerm, {});
    rb.query('HasCallForOpportunity', params.HasCallForOpportunity, {});
    rb.query('Tags', params.Tags, {});
    rb.query('SortField', params.SortField, {});
    rb.query('SortType', params.SortType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StudentProfilePagedData>;
    })
  );
}

getStudentProfiles.PATH = '/studentprofile';
